import { gql } from "graphql-request";

export const getQuotationDetail = gql`
query QutationDetails($id:String!){
  getQuotationDetail(id:$id){
      id
    user{
      username
    }
    opportunity{
      opportunityFrom
      id
      oppid
    }
    preferredBy{
      id
      username
    }
    businessPartner
      customer
   relatedName
    billingAddress
    shippingAddress
    contactPerson
    quoteDate
    dueDate
    accountingManager{
    id
      username
    }
    termsAndConditions
    additionalInformations
    subTotal
    businessPartner
    totalTaxAmount
    amountAndTax
    otherCharges
    otherChargesDescription
    discount
    discountPercentage
    totalAmount
    features
    quotationproductsSet{
      id
    user{
      username
    }
    productName{
       id
      productName
    }
    SKU
    HSNNumber
    comments
    quantity
    rate
    tax
    margin
    marginValue
    totalproductamount
    productDiscount
    productDiscountPercentage
    amount
    taxAmount
    
    }
  }
}
`;
export const getQuotationProductsDetail = gql`
  query QutationProduct($id: String!) {
    getQuotationProductsDetail(id: $id) {
      id
      user {
        username
      }
      productName {
        productName
      }
      SKU
      HSNNumber
      comments
      quantity
      rate
      tax
      margin
      marginValue
      totalproductamount
      productDiscount
      productDiscountPercentage
      amount
      taxAmount
    }
  }
`;
